<template>
  <div>
    <div class="item-detail-show" >
      <div class="item-detail-left">
        <div class="item-detail-big-img">
          <img :src="goodDetail.commerce.headUri" alt="">
        </div>
        <div class="item-detail-img-row">
        <!--轮播图-->
<!--          <div class="item-detail-img-small" v-for="(item, index) in goodDetail.commerce.carouselUris" :key="index" @mouseover="showBigImg(index)">-->
          <div class="item-detail-img-small" @mouseover="showBigImg()">
            <img :src="goodDetail.commerce.carouselUris" alt="">
          </div>
        </div>
      </div>
      <div class="item-detail-right">

        <div class="item-detail-name" style="margin-top: 6px">
            <span class="item-detail-express">名称：{{goodDetail.name}}</span>
        </div>
        <div class="item-detail-title" style="margin-top: 6px">
            <span class="item-detail-express">规格：{{goodDetail.model}}</span>
        </div>
        <div class="item-detail-title" style="margin-top: 6px">
            <span class="item-detail-express">编码：{{goodDetail.number}}</span>
        </div>
        <div class="item-detail-title" style="margin-top: 6px">
            <span class="item-detail-express">简称：{{goodDetail.shortName}}</span>
        </div>
        <div class="item-detail-title" style="margin-top: 6px">
            <span class="item-detail-express">品牌：{{goodDetail.registeredMark}}</span>
        </div>

<!--        <div class="item-detail-tag">-->
<!--          <p>-->
<!--            <span v-for="(item,index) in goodsInfo.tags" :key="index">【{{item}}】</span>-->
<!--          </p>-->
<!--        </div>-->
        <div class="item-detail-price-row">
          <div class="item-price-left">
            <div class="item-price-row">
              <p>
                <span class="item-price-title">今 日 价 格：</span>
                <span class="item-price">￥{{price.toFixed(2)}}</span>
              </p>
              <p>
                <span class="item-price-title">今 日 折 扣：</span>
                <span class="item-price">￥{{price.toFixed(2)}}</span>
              </p>
            </div>
          </div>
          <div class="item-price-right">
            <div class="item-remarks-sum">
            </div>
          </div>
        </div>
        <br>
        <div class="add-buy-car-box">
          <div class="add-buy-car">
            <div style="margin-top: 10px">
              吨数：
              <el-input-number v-model="weight" :min="0" size="mini" label="吨数"></el-input-number><br>
              包数：
              <el-input-number v-model="amount" :min="1" size="mini" label="包数" style="margin-top: 6px"></el-input-number>
            </div>
            <el-button class="goods-show-addCartBtn" @click="addCart(goodDetail)">加入购物车</el-button>
            <el-button class="goods-show-collectBtn" @click="addFavorites(goodDetail)">收藏</el-button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import store from '@/views/vuex/store';
import {queryGoodDetailById} from '@/api/system/good';
import { mapState, mapActions } from 'vuex';
import {saveCart} from "@/api/system/cart";
import {saveFavorites} from "@/api/system/favorites";
export default {
  name: 'detail',
  data () {
    return {
      price: 0,
      count: 1,
      selectBoxIndex: 0,
      imgIndex: 0,

      goodCartParams:{
        goodsId:'',
        goodsCode:'',
        goodsName:'',
        goodsRule:'',
        goodsAlias:'',
        logo:'禾丰',
        weight:'',
        amount:'',
        orgSaleId:'',
        // addData:'',
        // modifyData:'',
        // isPick:'false',
        // totalWeight:'',
        // totalAmount:'',
      },

      weight: '0',
      amount: '1',
      goodDetail:{
        // goodName:'',
        // goodModel:'',
        // goodNumber:'',
        // goodShortName:'',
        // goodRegisteredMark:'',
        // weight: '0',
        // amount: '1',
      },
    };
  },
  computed: {
    // ...mapState(['goodsInfo']),
  },
  methods: {
    ...mapActions(['addShoppingCart']),
    select (index1, index2) {
      this.selectBoxIndex = index1 * 3 + index2;
      this.price = this.goodsInfo.setMeal[index1][index2].price;
    },
    showBigImg (index) {
      this.imgIndex = index;
    },
    getGoodDetail(){
      let goodId = this.$route.query.id;
      // console.log("*******" + goodId);
      queryGoodDetailById(goodId).then(res=>{
         let good={
           commerce:{},
         };
         good.id = goodId;
         good.name = res.data.name;
         good.model = res.data.model;
         good.number = res.data.number;
         good.shortName = res.data.shortName;
         good.registeredMark = res.data.registeredMark;
         good.orgSaleId = res.data.orgSales[0].id;
         //当图片不为空时
         if(res.data.bdMaterialCommerce.headUri != null){
           good.commerce.headUri = res.data.bdMaterialCommerce.headUri;
         }else{
           good.commerce.headUri = "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png";
         }
         if(res.data.bdMaterialCommerce.carouselUris != null){
           good.commerce.carouselUris = res.data.bdMaterialCommerce.carouselUris;
         }else{
           good.commerce.carouselUris = "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png";
           console.log(good.commerce.carouselUris);
         }
         if(res.data.bdMaterialCommerce.bodyUri != null){
           good.commerce.bodyUri = res.data.bdMaterialCommerce.bodyUri;
         }else{
           good.commerce.bodyUri = "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png";
         }
         good.commerce.tenantId = res.data.bdMaterialCommerce.tenantId;
         this.goodDetail=good;
      })
    },
    addCart(goodDetail){
      this.goodCartParams.goodsId=goodDetail.id;
      this.goodCartParams.goodsCode=goodDetail.number;
      this.goodCartParams.goodsName=goodDetail.name;
      this.goodCartParams.goodsRule=goodDetail.model;
      this.goodCartParams.goodsAlias=goodDetail.shortName;
      if (goodDetail.goodRegisteredMark != null && goodDetail.goodRegisteredMark != '') {
        this.goodCartParams.logo=goodDetail.registeredMark;
      } else {
        this.goodCartParams.logo = '无';
      }
      this.goodCartParams.weight=this.weight;
      console.log(this.goodDetail.weight)
      this.goodCartParams.amount=this.amount;
      console.log(this.goodDetail.amount)
      this.goodCartParams.orgSaleId = goodDetail.orgSaleId;
      saveCart(this.goodCartParams).then(res => {
        if(res.code == 200){
          this.$message({
            offset:300,
            message:'添加到购物车成功',
            type:'success',
          })
        }else{
          this.$message({
            offset:300,
            message:'添加到购物车失败',
            type:'error',
          })
        }
      });
    },
    addFavorites(goodDetail){
      this.goodCartParams.goodsId=goodDetail.id;
      this.goodCartParams.goodsCode=goodDetail.number;
      this.goodCartParams.goodsName=goodDetail.name;
      this.goodCartParams.goodsRule=goodDetail.model;
      this.goodCartParams.goodsAlias=goodDetail.shortName;
      if (goodDetail.goodRegisteredMark != null && goodDetail.goodRegisteredMark != '') {
        this.goodCartParams.logo=goodDetail.registeredMark;
      } else {
        this.goodCartParams.logo = '无';
      }
      this.goodCartParams.orgSaleId = goodDetail.orgSaleId;
      saveFavorites(this.goodCartParams).then(res => {
        if(res.code == 200){
          this.$message({
            offset:300,
            message:'收藏成功',
            type:'success',
          })
        }else {
          this.$message({
            offset:300,
            message:'收藏失败',
            type:'error',
          })
        }
      })
    },
  },
  created () {
    this.getGoodDetail();
  },
  mounted () {
    const father = this;
    // setTimeout(() => {
    //   father.price = father.goodsInfo.setMeal[0][0].price || 0;
    // }, 300);
  },
  store
};
</script>


<style scoped>
/******************商品图片及购买详情开始******************/
.item-detail-show {
  width: 80%;
  margin-top: 100px;
  margin-left: 300px;
  display: flex;
  flex-direction: row;
  background-color: #fff;
  /*text-align: center;*/
  /*border: 1px solid #000000;*/
}
.item-detail-left {
  width: 350px;
  margin-right: 30px;
}
.item-detail-big-img {
  width: 350px;
  height: 350px;
  box-shadow: 0px 0px 8px #ccc;
  cursor: pointer;
}
.item-detail-big-img img {
  width: 100%;
}
.item-detail-img-row {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.item-detail-img-small {
  width: 68px;
  height: 68px;
  box-shadow: 0px 0px 8px #ccc;
  cursor: pointer;
}
.item-detail-img-small img {
  width: 100%;
}
/*商品选购详情*/
.item-detail-right {
  /*display: flex;*/
  /*flex-direction: row;*/
}
.item-detail-title p {
  color: #666;
  font-size: 20px;
}
.item-detail-express {
  font-size: 20px;
  padding: 2px 3px;
  /*background-color: #e4393c;*/
  /*color: #000000;*/
}
/*商品标签*/
.item-detail-tag {
  font-size: 12px;
  color: #e4393c;
}
/*价格详情等*/
.item-detail-price-row {
  /*padding: 5px;*/
  /*display: flex;*/
  /*flex-direction: row;*/
  /*justify-content: space-between;*/
  background-color: #f3f3f3;
}
.item-price-left {
  /*display: flex;*/
  /*flex-direction: column;*/
}
.item-price-title {
  color: #999999;
  font-size: 14px;
  margin-right: 15px;
}
.item-price-row {
  margin: 5px 0px;
}
.item-price {
  color: #e4393c;
  font-size: 23px;
  cursor: pointer;
}
.item-price-full-cut {
  margin-right: 5px;
  padding: 3px;
  color: #e4393c;
  font-size: 12px;
  background-color: #ffdedf;
  border: 1px dotted #e4393c;
  cursor: pointer;
}
.item-remarks-sum {
  padding-left: 8px;
  border-left: 1px solid #ccc;
}
.item-remarks-sum p {
  color: #999999;
  font-size: 12px;
  line-height: 10px;
  text-align: center;
}
.item-remarks-num {
  line-height: 18px;
  color: #005eb7;
}
.item-select {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
}
.item-select-title {
  color: #999999;
  font-size: 14px;
  margin-right: 15px;
}
.item-select-column {
  display: flex;
  flex-direction: column;
}
.item-select-row {
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
}
.item-select-box {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.item-select-img {
  width: 36px;
}
.item-select-box {
  padding: 5px;
  margin-right: 8px;
  background-color: #f7f7f7;
  border: 0.5px solid #ccc;
  cursor: pointer;
}
.item-select-box:hover {
  border: 0.5px solid #e3393c;
}
.item-select-box-active {
  border: 0.5px solid #e3393c;
}
.item-select-img img {
  width: 100%;
}
.item-select-intro p {
  margin: 0px;
  padding: 5px;
}
.item-select-class {
  padding: 5px;
  margin-right: 8px;
  background-color: #f7f7f7;
  border: 0.5px solid #ccc;
  cursor: pointer;
}
.item-select-class:hover {
  border: 0.5px solid #e3393c;
}
.add-buy-car-box {
  width: 100%;
  margin-top: 15px;
  border-top: 1px dotted #ccc;
}
.add-buy-car {
  margin-top: 15px;
}

/******************商品图片及购买详情结束******************/

/*****************新增开始******************/

.goods-show-addCartBtn{
  background-color: #FF0000;
  font-size: 17px;
  color: #FFFFFF;
  margin-top: 20px;
}

.goods-show-collectBtn{
  background-color: #FF0000;
  font-size: 17px;
  margin-left: 25px;
  color: #FFFFFF;
  margin-top: 20px;
}
/*****************新增结束******************/
</style>
